import React from 'react';

import { Session } from 'types/event.types';
import { GuestDataForRSVPControl, GuestActivity } from 'types/rsvp_control.types';
import { MultiSessionPlusOneGuest, PlusOneGuest } from 'types/plus-one.types';

export interface GuestSideSheetContextType {
  eventOrSessionId: number;
  guestData: GuestDataForRSVPControl;
  guestActivity: GuestActivity[];
  refetchGuestData: () => void;
  handleUpdateRefetch: () => void;
  closeSheet: () => void;
  selectedPlusOneId: number | null;
  setSelectedPlusOneId: (id: number | null) => void;
  selectedPlusOneGuest: PlusOneGuest | null | undefined;
  /** The session matching eventOrSessionId (undefined for single-session events) */
  selectedSession: Session | undefined;
  /** Sessions that have plusOneConfig with allowPlusOnes enabled */
  sessionsWithPlusOnes: Session[];
  /** All plus-ones from parent event for calculating session availability in MSE */
  allParentPlusOnes: MultiSessionPlusOneGuest[];
}

export const GuestSideSheetContext = React.createContext<GuestSideSheetContextType | null>(null);

export const useGuestSideSheetContext = (): GuestSideSheetContextType => {
  const context = React.useContext(GuestSideSheetContext);
  if (!context) {
    throw new Error('useGuestSideSheetContext must be used within a GuestSideSheet');
  }
  return context;
};
